function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Boc component for home page
 * 
 */
import * as React from 'react';
import './Need.scss';
import { PHOTOS } from '../../data/Data';
import Image from '../image/Image';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Need extends React.Component {
  render() {
    const {
      content,
      passportPhoto,
      licencePhoto
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "Need",
      children: [/*#__PURE__*/_jsx("div", {
        className: "part1",
        children: content.map((item, index) => {
          return /*#__PURE__*/_jsxs("div", {
            className: "box",
            children: [/*#__PURE__*/_jsx("div", {
              className: "image",
              children: /*#__PURE__*/_jsx("img", {
                src: `/images/${item.icon}`,
                alt: ""
              })
            }), /*#__PURE__*/_jsx("h4", {
              className: "title",
              children: item.title
            }), /*#__PURE__*/_jsx("div", {
              className: "content",
              dangerouslySetInnerHTML: {
                __html: item.content
              }
            })]
          }, index);
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "part2",
        children: [/*#__PURE__*/_jsx("div", {
          className: "image",
          children: PHOTOS.map((item, index) => {
            return /*#__PURE__*/_jsx(Image, {
              ...item
            }, index);
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "content",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "title",
            children: passportPhoto.title
          }), /*#__PURE__*/_jsx("div", {
            className: "copy",
            dangerouslySetInnerHTML: {
              __html: passportPhoto.content
            }
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "part3",
        children: [/*#__PURE__*/_jsx("div", {
          className: "image",
          children: /*#__PURE__*/_jsx("img", {
            src: `/images/${licencePhoto.icon}`,
            alt: ""
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "content",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "title",
            children: licencePhoto.title
          }), /*#__PURE__*/_jsx("div", {
            className: "copy",
            dangerouslySetInnerHTML: {
              __html: licencePhoto.content
            }
          })]
        })]
      })]
    });
  }
}
_defineProperty(Need, "defaultProps", {
  content: []
});
export default Need;